module.exports = __webpack_public_path__ + "static/media/Seleccionar.1bae0f48.png";